<script lang="ts">
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { ArrowBack } from '@athena-lib/Icons';
  import { Image } from '@athena-lib/Image';
  import { Link } from '@athena-lib/Link';
  import { Text } from '@athena-lib/Text';

  type Props = {
    backUrl: string;
    stickerAppLogoUrl: string;
  };

  const { backUrl, stickerAppLogoUrl }: Props = $props();
  const translations = getCommonTranslations();
</script>

<div class="flex w-full bg-st-black px-3 py-2">
  <div class="flex w-1/3 items-center">
    <Link href={backUrl} class="flex items-center gap-2 text-st-white">
      <ArrowBack sizeClass="size-8 lg:size-6" />
      <Text class="sr-only lg:not-sr-only" element="span" color="light" bold
        >{translations.backToShopping}</Text
      >
    </Link>
  </div>
  <div class="flex w-1/3 items-center justify-center">
    <Link href="/">
      <Image src={stickerAppLogoUrl} alt="Sticker App" imgClass="max-h-16 w-auto" />
    </Link>
  </div>
</div>
